import { Model } from 'app/model/backendmodel';
import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Metamodel } from 'app/model/base/model';

import { Activity } from 'app/model/pipeline/activity';
import { Owned } from 'app/model/base/named';
import {
    convertStoreSettingsToResource,
    convertStoreSettingsToModel
} from '../copysource/store-read-settings/store-read-settings.util';
import {
    convertFormatSettingsToResource,
    convertFormatSettingsToModel
} from '../copysource/format-read-settings/format-read-settings.util';
import { JsonSink } from 'app/model/pipeline/copysink/json.sink';
import { CopySinkAdapter } from 'app/model/adapters/activities/copysink/copysink.adapter';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(JsonSink),
    asynchronous: true,
    adapts: {
        type: '*',
        storeSettings: '*',
        formatSettings: '*'
    }
})
export class JsonSinkAdapter extends CopySinkAdapter<JsonSink, Model.JsonSink> {
    protected override async _toResource(model: JsonSink): Promise<Model.JsonSink> {
        const result: Model.JsonSink = {
            type: JsonSink.MODEL.name
        };

        await convertStoreSettingsToResource(model.storeSettings, result, this.context);
        await convertFormatSettingsToResource(model.formatSettings, result, this.context);
        return result;
    }

    protected override async _toModel(resource: Model.JsonSink, owner: Activity): Promise<JsonSink> {
        const result = Owned.create<JsonSink>(Metamodel.modelFor(JsonSink), owner);

        await convertStoreSettingsToModel(resource.storeSettings, result, this.context);
        await convertFormatSettingsToModel(resource.formatSettings, result, this.context);
        return result;
    }
}
